module.exports = __webpack_public_path__ + "static/img/rpa.0c2e156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rpa.png
// module id = AHqT
// module chunks = 9